import { Index } from '../features/displayError/Index';

export interface DisplayErrorProps {
  message?: string;
}

export const DisplayError = ({ message }: DisplayErrorProps) => {
  return <Index message={message} />;
};
